import { TextStylePreset, Typography } from '@vivaldis/antd-ui'
import { PayslipsTabPayslipsQuery_payslips as Payslip } from '../../../graphql/__generated__/PayslipsTabPayslipsQuery'

interface Props {
  payslip: Payslip
}

export const Key = ({ payslip }: Props) => {
  return (
    <Typography.Text preset={TextStylePreset.Regular14}>
      {payslip.key}
    </Typography.Text>
  )
}
